import { Component, OnInit, ViewChild, Input, AfterContentInit, AfterViewInit, AfterContentChecked } from '@angular/core';
import { Observable } from 'rxjs';
import { NavsComponent } from 'src/app/shared/ui/tabs/navs.component';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.scss']
})

export class DetalleComponent implements OnInit, AfterContentInit {
  
  
  Toolbar: string[] = [];                                   // INSERT, UPDATE, DELETE, SELECT, ESPECIAL
  intSYS02CON: string = '';
  breadCrumbItems: Array<{}>;
  campos$: Observable<any>;
  excluidos = [ 'NOTIFICACION_COMPONENT', 'ESTUDIANTE_COMPONENT', 'ARCHIVOS_COMPONENT',
                'DOCENTENOTAS_COMPONENT', 'DOCENTEAUSENCIAS_COMPONENT', 'DOCENTE_COMPONENT',
                'FLEXMONSTER_COMPONENT'];

  @Input() strWsURL;
  @Input() strTipo;
  @Input() pantalla;
  @Input() strSYS02TIP;
  @Input() JSONllavesMantenimiento;
  @ViewChild('navsEdit') editNavTemplate;
  @ViewChild(NavsComponent) navsComponent;


  ngOnInit(): void {
    if (this.pantalla == undefined) {
      this.pantalla = 1;
    }
  }

  ngAfterContentInit() {
    if(this.JSONllavesMantenimiento != null ){
      setTimeout(() => {
       this.abrirNuevoNav(this.JSONllavesMantenimiento);
      }, 500);
      
    }
 }

  abrirNuevoNav(strData: any) {   
    let titulo = strData.TITULO;
    this.navsComponent.openNav(titulo, this.editNavTemplate, strData, true);
  }

  componentesExcluidos(tipo){
    if (this.excluidos.includes(tipo) || this.strSYS02TIP =='TED' || this.strSYS02TIP =='LSN') {
      return false
    }else{
      return true;
    }
  }

}
